
import { DownOutlined } from '@ant-design/icons-vue';
import { computed, ComputedRef, defineComponent } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { StateType as UserStateType, CurrentUser } from "@/store/user";
import {message} from "ant-design-vue";
interface RightTopUserSetupData {
    t: (key: string | number) => string;
    currentUser: ComputedRef<CurrentUser>;
    onMenuClick: (event: any) => Promise<void>;
    helpDoc: (e: MouseEvent) => void;
}
export default defineComponent({
    name: 'RightTopUser',
    components: {
        DownOutlined
    },
    setup(): RightTopUserSetupData {
        const store = useStore<{user: UserStateType}>();
        const router = useRouter();
        const { t } = useI18n();

      //帮助中心
      const helpDoc = (e: MouseEvent) => {
        message.warning('文档整理中，稍后上线！')
      }

        // 获取当前登录用户信息
        const currentUser = computed<CurrentUser>(()=> store.state.user.currentUser);

        // 点击菜单
        const onMenuClick = async (event: any) => {
            const { key } = event;
            if (key === 'logout') {
                const res: boolean = await store.dispatch('user/logout');
                localStorage.removeItem('userCode')
                localStorage.removeItem('userMsg')
                localStorage.removeItem('locale')
                localStorage.removeItem('oneType')
                if(res === true) {
                    router.replace({
                        path: '/user/login',
                        query: {
                            redirect: router.currentRoute.value.path,
                            ...router.currentRoute.value.query
                        }
                    })
                }
            }else{
                router.replace({
                    path: '/personal/account',
                })
            }

        }



        return {
            t,
            currentUser,
            onMenuClick,
            helpDoc
        }
    }
})
